const stickyInit = (header: HTMLElement) => {
  const topbar: HTMLElement = header.querySelector('.header__topbar');
  const topbarHeight: number = topbar.clientHeight;
  const body: any = document.querySelector('.body');
  const headerHeight: number = header.clientHeight;

  window.addEventListener('scroll', () => {
    if (window.scrollY > topbarHeight) {
      header.classList.add('header--sticky');
      body.style.paddingTop = `${headerHeight}px`;
    } else {
      header.classList.remove('header--sticky');
      body.style.paddingTop = '';
    }
  });
};

export default stickyInit;
